// @flow
import MessageBlock from './MessageBlock';

export default class TextBlock extends MessageBlock {
  text: string;
  constructor(text: string) {
    super();
    this.text = text;
  }
}
